<template>
  <!--编辑成品-->
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading="loading" type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import Bus from '@/assets/js/eventBus'
import store from '@/store'
export default {
  data () {
    return {
      loading: false,
      data: {
        name: '', // 型号
        content: '', // 含量
        describe: '', // 描述
        price: null // 价格
      },
      options: [
        {
          name: 'name',
          note: '型号',
          type: 'String'
        },
        {
          name: 'content',
          note: '含量',
          type: 'String',
          // validators: [
          //   (val) => val ? null : '含量不可为空'
          // ]
        },
        {
          name: 'describe',
          note: '描述',
          type: 'String'
        },
        {
          name: 'price',
          note: '价格',
          type: 'Number',
          disabled: true
        }
      ]
    }
  },
  async mounted () {
    let d = {
      proportion: this.proportion,
      model: this.modelId,
      workShop: this.workShop
    }
    if (this.isBatching) {
      this.options.splice(2, 0, {
        name: 'clientid',
        note: '客户',
        type: 'Pointer',
        targetClass: 'Client',
        listWhere: (where) => {
          // if (this.$store.state.user.adminRole === 'sale' || this.$store.state.user.adminRole === 'admin') {
          //   where.userid = this.$store.state.user.objectId
          // }
          if (store.state.user && store.state.user.allClient === 'Yes') { } else {
            where.userid = store.state.user.objectId
          }
        },
        validators: [
          (val) => val ? null : '不可为空'
        ]
      })
      this.$set(this.data, 'clientid', '')
    } else {
      this.options[0].validators = [
        (val) => val ? null : '型号不可为空'
      ]
    }
    this.data = { ...this.data, ...d }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    async submit () {
      // 验证必填项
      let erros = await this.$refs.input.validate()
      if (Object.keys(erros).length) return
      // 确保名称不相同
      this.loading = !this.loading
      const { data: res } = await this.$tkParse.get('/classes/finishProduct', {
        params: {
          where: {
            isBatching: false,
            name: this.data.name
          }
        }
      })
      if (res.results.length > 0 && !this.isBatching) {
        this.loading = !this.loading
        throw this.$notification.error({
          message: '保存失败',
          description: '成品型号已存在，请修改型号'
        })
      }
      const data = this.data
      if (this.isBatching) {
        data.isBatching = true
        data.userid = this.$store.state.user.objectId
      } else {
        data.isBatching = false
      }
      await this.$modelAjax.post('finishProduct', data).catch(e => {
        this.loading = !this.loading
        throw this.$notification['error']({
          message: '保存失败',
          description: '保存失败，请重新尝试'
        })
      })
      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    }
  },
  beforeDestroy () {
    Bus.$off('isChildren', this.receive)
  },
  props: {
    vm: null,
    title: String,
    proportion: null,
    modelId: null,
    workShop: null,
    isBatching: {
      type: Boolean,
      defult: false
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
</style>
